import ImageMapIsometrySection from './ImageMapIsometrySection';

export default ImageMapIsometrySection;